import { getAuthCode } from "./getAuthCode";
export const RegenerateYourPost = async(id,feedback,ideaType) => {
    let endpointUrl = process.env.REACT_APP_BACKEND_URL + "/regenPost";
    try {
    const response = await fetch(endpointUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body:JSON.stringify({auth_code:await getAuthCode(),id:id,feedback : feedback})
    });
    if (!response.ok) {
        return {success:false}
    }
    if(response.ok){
      window.location.reload();
      return{success:true}
    }
  } catch (error) {
    // Handle network or other errors
    console.error("Error:", error.message);
  }
}